import React from "react";
import { useShopContext } from "../../../context/ShopContext";
import ShopOrder from "../ShopOrder";

import "./style.scss";

const className = 'user-prizes-modal';

export default ({ $locale }) => {
    const { orders } = useShopContext();

    return <div className={className}>
        <div className={`${className}-title`}>{$locale.get('shop.myPrizes')}</div>
        {orders.length ?
            <div className={`${className}-prizes-container scrollable`}>{orders.map(order => <ShopOrder key={order.id} prize={order.product} $locale={$locale} />)}</div>
            : <div>{$locale.get('shop.myPrizes.empty')}</div>
        }
    </div>
}
